module.exports = __webpack_public_path__ + "img/home_anli.51034bb3.jpg";